import { createAction, props } from '@ngrx/store';
import {FavoritesDTO} from "@signature-it/ngx-entity/models";
export const GET_PREVIEWS = '[Entity] Get Previews';
export const GET_PREVIEWS_SUCCESS = '[Entity] Get Previews Success';
export const GET_PREVIEWS_ERROR = '[Entity] Get Previews Error';
export const ADD_FAVORITE = '[Entity] Add Favorite';
export const REMOVE_FAVORITE = '[Entity] Remove Favorite';
export const GET_FAVORITES = '[Entity] GET_FAVORITES';
export const GET_FAVORITES_SUCCESS = '[Entity] GET_FAVORITES_SUCCESS';
export const GET_FAVORITES_FAILURE = '[Entity] GET_FAVORITES_FAILURE';
export const ADD_FAVORITE_SUCCESS = '[Entity] ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_FAILURE = '[Entity] ADD_FAVORITE_FAILURE';
export const REMOVE_FAVORITE_SUCCESS = '[Entity] REMOVE_FAVORITE_SUCCESS';
export const REMOVE_FAVORITE_FAILURE = '[Entity] REMOVE_FAVORITE_FAILURE';
export const getPreviews = createAction(GET_PREVIEWS);
export const getPreviewsSuccess = createAction(GET_PREVIEWS_SUCCESS, props<{ previews: Array<any> }>());
export const getPreviewsError = createAction(GET_PREVIEWS_ERROR, props<{ error: any }>());
export const getFavorites = createAction(GET_FAVORITES);
export const getFavoritesSuccess = createAction(GET_FAVORITES_SUCCESS, (payload: FavoritesDTO[]) => { return  {payload}});
export const getFavoritesFailure = createAction(GET_FAVORITES_FAILURE);
export const addFavorite = createAction(ADD_FAVORITE, (payload: any) => { return {payload}});
export const addFavoriteSuccess = createAction(ADD_FAVORITE_SUCCESS, (payload: any) => payload);
export const addFavoriteFailure = createAction(ADD_FAVORITE_FAILURE);
export const removeFavorite = createAction(REMOVE_FAVORITE, (payload: any) => { return {payload}});
export const removeFavoriteSuccess = createAction(REMOVE_FAVORITE_SUCCESS, (payload: any) => payload);
export const removeFavoriteFailure = createAction(REMOVE_FAVORITE_FAILURE);
